import React, { Component } from 'react';
import { Col, Label } from 'reactstrap';
import Select from 'react-select';

class CSVColumnSelector extends Component {
    state ={
        selected: undefined
    }
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handler = this.props.handler.bind(this);
        this.graphic = this.props.graph.bind(this);
        this.dataSource = this.props.data;
        this.name = this.props.name;
    }

    onChange(e){
        this.graphic(false, {});
        if(!e) {
            this.setState({
                selected: null
            });
            this.handler(null);
            return;
        }
        this.setState({selected: e.value});
        this.handler(e.value);
    }
    
    render() {
        return (
            <Col className="Main-Center" id="col2" lg="4">
                <Label for="exampleDate">{this.name}</Label>
                <Select
                    name="client-dropdown"
                    placeholder={this.name}
                    className="clientSelector"
                    clearable={true}
                    id={this.props.id}
                    value={this.state.selected}
                    onChange={this.onChange}
                    options={this.dataSource}
                />
            </Col>
        );
    }
}

export default CSVColumnSelector;